import { JsonSchema } from '@jsonforms/core';
import { Feature, Polygon } from 'geojson';
import { NumberId } from 'src/app/shared/state/number-id.model';
import { SimulationRatesParameters } from './attendance-rate.model.generated';
import { MitraNetworkParameters } from './network-parameters.model.generated';

export interface Simulation extends NumberId {
  name: string;
  parameters: MitraNetworkParameters;
  areas_definition: Feature<Polygon>[];
  attendance_rates: SimulationRatesParameters;
  status?: SimulationStatus;
  status_description?: string;
  min_collective_horiz?: number;
  min_collective_vert?: number;
}

export function createSimulation(params: Partial<Simulation>) {
  return {
    name: '',
    parameters: {
      horizontal_access_per_pon: null,
      horizontal_settings: {
        splitter_sections: [],
        bus_box_types: []
      },
      vertical_settings: {
        types: []
      },
      horizontal_collective_settings: {
        types: []
      },
      feeding_box_types: [{}],
      attendance_box_types_horiz: [],
      attendance_box_types_vert: [{}],
      attendance_box_types_horiz_collective: [{}],
      feeding_box_bus_types: [],
      central_office_settings: {
        internal_cable_max_length: 150
      },
      max_cables_per_edge: 6,
      internal_feeding_cables_types: [
        { connector_type: 'NONE' }
      ],
      feeding_cables_types: [{}],
      cables_types: {
        internal_underground: 'DD-LSZH',
        feeding_underground: 'DD-TS-NR',
        feeding_aerial: 'AS-80-S-NR',
        distribution_underground: 'DD-TS-NR',
        distribution_aerial: 'AS-80-S-NR',
        vertical_termination_underground: 'ASU-80-S-NR',
        vertical_termination_aerial: 'ASU-80-S-NR',
        drop_bus_aerial: 'AS-80-LSZH-BLI'
      },
      vertical_attendance_cable_types: [{}]
    },
    areas_definition: [],
    attendance_rates: [],
    ...params
  } as Simulation;
}

export enum SimulationStatus {
  WAITING = 0,
  PROCESSING_ALGORITHM = 1,
  ALGORITHM_PROCESSED = 2,
  EXECUTING_POST_PROCESSING = 3,
  DONE = 4,
  DRAFT = 8,
  ERROR = 9
}
export interface CheckSimulatioArea {
  'areas_definition': Feature<Polygon>[];
  'attendance_rates': SimulationRatesParameters;
}

export interface SimulationAreaResult {
  classes: SimulationAreaResultClass[];
}

export interface SimulationAreaResultClass {
  'economic_class': string;
  'individual_res_abs': number;
  'individual_nres_abs': number;
  'collective_res_abs': number;
  'collective_nres_abs': number;
  'individual_res_rel': number;
  'individual_nres_rel': number;
  'collective_res_rel': number;
  'collective_nres_rel': number;
}

export interface SimulationAreaDemand {
  horiz: SimulationAreaDemandData;
  vert: SimulationAreaDemandData;
  land: number;
  total: number;
  RA: number;
  RB: number;
  RC: number;
  RD: number;
  RE: number;
  NA: number;
  NB: number;
  NC: number;
  ND: number;
}

export interface SimulationAreaDemandData {
  RA: number;
  RB: number;
  RC: number;
  RD: number;
  RE: number;
  NA: number;
  NB: number;
  NC: number;
  ND: number;
  TOTAL: number;
}

export interface SimulationValidationResult {
  areas: Feature<Polygon>[];
  total: {
    total_abs: SimulationAreaDemand,
    total_rel: SimulationAreaDemand
  };
}


export class SimulationParams {
  'simulation_params_schema': JsonSchema;
  'simulation_params_default': object;
  'simulation_attendance_rates_schema': JsonSchema;
  'simulation_attendance_rates_default': SimulationRatesParameters;
}

